import { useDispatch } from 'react-redux';

import { MainStoreDispatch } from 'store/main/MainStoreDispatch';

export const useMainDispatch: () => MainStoreDispatch = useDispatch;
